import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute } from '@angular/router';
import { ComponentService } from '../../services/component.service';
import { ResetPasswordComponent } from '../reset-password';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Reset Component
 */
let ResetComponent = class ResetComponent {
    constructor(httpClient, route, compService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.route = route;
        this.compService = compService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.statusMessage = '';
        this.showEmailForm = true;
        this.passwordNotStrong = false;
        this.displayMessage = true;
        this.resetData = {};
        this.passwordsSame = true;
        this.statusMessageSetPassword = '';
        this.resetPasswordStatus = false;
        // the API refused the new password because it equals the current one; the link stays valid
        this.passwordSameAsOld = false;
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.textColor = '';
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this.resetData.password_confirmation = '';
        this.resetData.password = '';
        this.route.params.subscribe((params) => {
            this.token = params['hash'];
            this.httpClient.get('user/resetpasswordconfirm/' + this.token).subscribe((result) => {
                this.statusMessage = result['message'];
                this.showEmailForm = true;
                this.resetData.token = this.token;
            }, (error) => {
                this.statusMessage = error.error['message'];
                this.showEmailForm = false;
            });
        });
    }
    resetAgain() {
        this.compService.openModal(ResetPasswordComponent);
    }
    comparePassword() {
        if (this.resetData.password === this.resetData.password_confirmation && this.resetData.password.length > 3 && this.resetData.password.length) {
            this.passwordsSame = true;
            this.errorPassword = false;
        }
        else {
            this.errorPassword = true;
            this.passwordsSame = false;
        }
    }
    checkPasswordStrength() {
        const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,64}$/;
        if (passRegex.test(this.resetData.password) === false) {
            this.passwordNotStrong = true;
            return false;
        }
        else {
            this.passwordNotStrong = false;
        }
        return true;
    }
    removeMessage() {
        this.checkPasswordStrength();
        this.displayMessage = false;
        this.passwordSameAsOld = false;
    }
    keyEnter(event) {
        if (event.keyCode === 13) {
            this.sendPasswords();
        }
    }
    sendPasswords() {
        this.comparePassword();
        if (this.resetData.password === this.resetData.password_confirmation) {
            if (!this.checkPasswordStrength()) {
                this.passwordNotStrong = true;
            }
            else {
                this.passwordSameAsOld = false;
                this.httpClient.post('user/resetpasswordcomplete', this.resetData).subscribe((success) => {
                    this.statusMessageSetPassword = success['message'];
                    this.resetPasswordStatus = true;
                }, (error) => {
                    if (error.error && error.error['message'] === 'PASSWORD_SAME_AS_OLD') {
                        // an account flagged to set a new password repeated its current one:
                        // the link is still valid, so the form stays for a different password
                        this.passwordSameAsOld = true;
                        return;
                    }
                    this.statusMessageSetPassword = error.error['message'];
                    this.resetPasswordStatus = true;
                });
            }
        }
        else if (!this.passwordsSame) {
            this.errorPassword = true;
            this.passwordNotStrong = false;
        }
    }
};
ResetComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: ComponentService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ResetComponent = __decorate([
    Component({
        selector: 'ecd-reset',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./reset.component.html")).default
    })
], ResetComponent);
export { ResetComponent };
